export default __webpack_public_path__ + "static/media/branding_m.109f0197.jpg";